<template>
  <b-modal v-model="innerModal" size="sm" hide-footer>
    <template v-slot:default="">
      <color-picker v-model="innerColor" class="modal-body" />
    </template>
  </b-modal>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { Compact } from 'vue-color'

export default {
  name: 'WhiteboardColorPickerModal',
  components: {
    'color-picker': Compact
  },
  props: {
    modal: Boolean
  },
  data() {
    return {
      innerModal: false,
      innerColor: '#000000'
    }
  },
  computed: {
    ...mapGetters({
      color: 'whiteboard/color'
    })
  },
  methods: {
    ...mapMutations({
      setColor: 'whiteboard/setColor'
    })
  },
  watch: {
    modal: function(value) {
      this.innerModal = value
    },
    innerModal: function(value) {
      this.$emit('toggleModal', value)
    },
    innerColor: function(value) {
      this.setColor(value.hex)
    }
  }
}
</script>

<style scoped lang="scss">
.modal-body {
  margin: auto;
}
</style>
